import "core-js/modules/es.array.iterator.js";
import { InputSelectManager, InputTypeEnum } from '@isyc-react/form/modules/input/manager';
import { nsnewo } from "../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const AcademicRecordProgramSelectorComponent = props => {
  var _currentProgramRecord;
  const {
    onChange,
    programRecordList
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  const selectOptions = React.useMemo(() => {
    if (!programRecordList) {
      return [];
    }
    return programRecordList.map(e => ({
      value: e.ID.toString(),
      label: e.trainingProgramName,
      data: e
    }));
  }, [programRecordList]);
  const [currentProgramRecordOption, setCurrentProgramRecordOption] = React.useState();
  React.useEffect(() => {
    if (!selectOptions) {
      setCurrentProgramRecordOption(undefined);
    } else {
      setCurrentProgramRecordOption(selectOptions[0]);
    }
  }, [selectOptions]);
  React.useEffect(() => {
    onChange(currentProgramRecordOption === null || currentProgramRecordOption === void 0 ? void 0 : currentProgramRecordOption.data);
  }, [currentProgramRecordOption]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row pb-4 gx-5 program-selector align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-auto pb-3 pb-xl-0"
  }, /*#__PURE__*/React.createElement("label", {
    className: "text-primary mb-0"
  }, t('newo.academicRecord.selector.trainingProgramLabel'))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-4 pb-3 pb-xl-0"
  }, /*#__PURE__*/React.createElement(InputSelectManager, {
    inputManagerType: InputTypeEnum.NORMAL,
    placeholder: 'Selecciona una opción',
    options: selectOptions,
    value: currentProgramRecordOption,
    onChange: e => setCurrentProgramRecordOption(e !== null && e !== void 0 ? e : undefined)
  })), currentProgramRecordOption && /*#__PURE__*/React.createElement("div", {
    className: "col-xl-auto status-exp lh-sm"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-clipboard-text text-primary mdi-24px pe-3"
  }), /*#__PURE__*/React.createElement("span", null, (_currentProgramRecord = currentProgramRecordOption.data) === null || _currentProgramRecord === void 0 ? void 0 : _currentProgramRecord.stateLabel))));
};